import {categoryColor} from 'utils/Helper';

export default theme => ({
  container: {
    border: '1px solid #E0E0E0',
    padding: 15,
    wordBreak: 'break-word'
  },
  mainContentContainer: {
    minHeight: '100%'
  },
  contentDetailsWrapper: {
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row-reverse'
    }
  },
  title: {
    padding: '0 10px 3px 10px',
    borderBottom: '1px solid #e6e6e6',
    marginBottom: '15px',
    color: categoryColor('categoryId', 'primary', 500, '#970b07'),
  },
  overTitle: {
    fontSize: 13,
    color: '#999',
    paddingRight: 10
  },
  imageRoot: {
    height: 'auto',
    background: '#222'
  },
  image: {
    maxHeight: 330,
    height: 'auto'
  },
  content: {
    fontSize: 16,
    paddingBottom: 55,
    '& img': {
      maxWidth: '100%'
    },
    '& a' : {
      color: categoryColor('categoryId', 'primary', 800, '#970b07'),
    },
  },
  postActions: {
    textAlign: 'left'
  }
})

